import { NEWSListReducer } from "../reducer/NewsListReducer";

export const reducer = NEWSListReducer;
